import React from 'react';
import Utils from "utils";
import { ReportingService } from 'services/http';
import { CustomAVGKpiHoc, CustomDurationKPIHoc } from 'components/pages';

export const QualityKpis = () => {

    const filterSearchParam = JSON.parse(new URLSearchParams(window.location.search).get("filter"));

    return (
        <>
            <CustomAVGKpiHoc httpService={() => ReportingService.getInterventionAVGResponse(Utils.buildFilterCriteria(filterSearchParam))} />
            <CustomDurationKPIHoc
                httpService={() => ReportingService.getTotalTasksByDelay(Utils.buildFilterCriteria(filterSearchParam))}
                title="Nbr Interventions by delay"
                templates={["archived", "completed"]}
            />
        </>
    );
}
